import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectAtiPayments: "selectAtiPayments [Action]",
  selectAtiPaymentsLoading: "selectAtiPaymentsLoading [Action]",
  selectAtiPaymentsAsync: "selectAtiPaymentsAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const selectAtiPaymentsReducer = (
  state = inistiaState,
  { type, payload },
) => {
  switch (type) {
    case actionTypes.selectAtiPayments:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectAtiPaymentsLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectAtiPaymentsLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "payment",
    method_type: "select_ati_payments",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectAtiPayments,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectAtiPaymentsLoading,
      payload: false,
    });
  }
}

export function* selectAtiPayments() {
  yield takeLatest(actionTypes.selectAtiPaymentsAsync, handleWorker);
}
